import { Component, OnInit, Input, NgZone, inject } from '@angular/core';
import { Image, ImageModule } from '@teamfoster/sdk/image';

import { CommonModule } from '@angular/common';
import { InViewModule } from '@teamfoster/sdk/in-view';
import { RouterModule } from '@angular/router';
import { ButtonModule } from '@teamfoster/sdk/button';
import { Header } from 'src/app/core/models/header.model';
import { TextShapeComponent } from '../text-shape/text-shape.component';
import { BigTextComponent } from '../big-text/big-text.component';
import { DictionaryNgrxModule } from '@teamfoster/sdk/dictionary-ngrx';
import { DynamicHooksModule } from 'ngx-dynamic-hooks';
import { TextUtilityModule } from '@teamfoster/sdk/text-utility';
import { IconModule } from '@teamfoster/sdk/icon';
import { AnimationOptions } from 'ngx-lottie';
import { BehaviorSubject } from 'rxjs';
import SplittingDirective from 'src/app/animations/directives/splitting.directive';
import { CoreModule } from '../../core/core.module';
import { HighlightPipe } from 'src/app/core/pipes/highlight.pipe';

@Component({
  selector: 'app-header',
  standalone: true,
  templateUrl: './header.component.html',
  imports: [
    CommonModule,
    InViewModule,
    ImageModule,
    RouterModule,
    ButtonModule,
    TextShapeComponent,
    BigTextComponent,
    DictionaryNgrxModule,
    DynamicHooksModule,
    TextUtilityModule,
    IconModule,
    SplittingDirective,
    HighlightPipe,
  ],
})
export class HeaderComponent implements OnInit {
  private zone = inject(NgZone);

  @Input() header?: Header;
  @Input() image?: Image;
  @Input() title?: string;
  @Input() backgroundTitle?: string;

  @Input() inviewPort: boolean = false;

  constructor() {}

  options$ = new BehaviorSubject<AnimationOptions>({});

  ngOnInit(): void {
    this.zone.runOutsideAngular(() => {
      setTimeout(() => {
        this.options$.next({
          path: '/assets/lottie-files/squiggle-example.json',
          loop: false,
          autoplay: true,
        });
      }, 500);
    });
  }

  get headerImage() {
    return this.image?.url ? this.image : this.header?.image;
  }

  get hasContent() {
    return this.header?.text || this.header?.button?.url;
  }

  //inViewChange(e: boolean) {
  //  this.inviewPort = e;
  //  if (e) {
  //    this.inView.emit(null);
  //  }
  //}
}
